<template>
  <div >
    <global-header></global-header>
    <router-view></router-view>
    <a-back-top />
  </div>
</template>

<script>
import GlobalHeader from '../components/global-header'

export default {
  name: 'basic-layout',

  components: {
    GlobalHeader
  }
}
</script>
